export const DeliveryAddressActionTypes = {
    FETCH_DELIVERY_ADDRESS_REQUEST:
        "@@DeliveryAddress/FETCH_DELIVERY_ADDRESS_REQUEST",
    FETCH_DELIVERY_ADDRESS_SUCCESS:
        "@@DeliveryAddress/FETCH_DELIVERY_ADDRESS_SUCCESS",
    FETCH_DELIVERY_ADDRESS_FAILURE:
        "@@DeliveryAddress/FETCH_DELIVERY_ADDRESS_FAILURE",

    FETCH_DELIVERY_ADDRESS_ID_REQUEST:
        "@@DeliveryAddress/FETCH_DELIVERY_ADDRESS_ID_REQUEST",
    FETCH_DELIVERY_ADDRESS_ID_SUCCESS:
        "@@DeliveryAddress/FETCH_DELIVERY_ADDRESS_ID_SUCCESS",
    FETCH_DELIVERY_ADDRESS_ID_FAILURE:
        "@@DeliveryAddress/FETCH_DELIVERY_ADDRESS_ID_FAILURE",

    CREATE_DELIVERY_ADDRESS_REQUEST:
        "@@DeliveryAddress/CREATE_DELIVERY_ADDRESS_REQUEST",
    CREATE_DELIVERY_ADDRESS_SUCCESS:
        "@@DeliveryAddress/CREATE_DELIVERY_ADDRESS_SUCCESS",
    CREATE_DELIVERY_ADDRESS_FAILURE:
        "@@DeliveryAddress/CREATE_DELIVERY_ADDRESS_FAILURE",

    DELETE_DELIVERY_ADDRESS_REQUEST:
        "@@DeliveryAddress/DELETE_DELIVERY_ADDRESS_REQUEST",
    DELETE_DELIVERY_ADDRESS_SUCCESS:
        "@@DeliveryAddress/DELETE_DELIVERY_ADDRESS_SUCCESS",
    DELETE_DELIVERY_ADDRESS_FAILURE:
        "@@DeliveryAddress/DELETE_DELIVERY_ADDRESS_FAILURE",

    UPDATE_DELIVERY_ADDRESS_REQUEST:
        "@@DeliveryAddress/UPDATE_DELIVERY_ADDRESS_REQUEST",
    UPDATE_DELIVERY_ADDRESS_SUCCESS:
        "@@DeliveryAddress/UPDATE_DELIVERY_ADDRESS_SUCCESS",
    UPDATE_DELIVERY_ADDRESS_FAILURE:
        "@@DeliveryAddress/UPDATE_DELIVERY_ADDRESS_FAILURE",
};
